// extracted by mini-css-extract-plugin
export default {"ag-styles":"h_g","aboutPage":"h_2","team":"h_3","footer":"h_4"};